<template>
    <mySubPage>
        <div slot="header">
            <myNav>{{$t('mod_info')}}</myNav>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" :rules="rule" label-width="120px">
            <el-row>
                <el-col :span="24">
                    <el-form-item :label="$t('cname')" prop="mod_cname">
                        <el-input v-model="formData.mod_cname" :placeholder="$t('input')" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" v-for="(item,index) in fee_cat" :key="fee_cat.cat_id">
                    <el-form-item :label="item.cat_cname">
                        <el-input v-model="item.fee_amt" :placeholder="$t('input')">
                            <span slot="append">{{$t("price_unit")}}</span>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12"><el-form-item :label="$t('add_user')"><el-input v-model="formData.add_user" disabled></el-input></el-form-item></el-col>
                <el-col :span="12"><el-form-item :label="$t('add_time')"><el-input v-model="formData.add_time" disabled></el-input></el-form-item></el-col>
            </el-row>
            <el-row>
                <el-col :span="12"><el-form-item :label="$t('upd_user')"><el-input v-model="formData.upd_user" disabled></el-input></el-form-item></el-col>
                <el-col :span="12"><el-form-item :label="$t('upd_time')"><el-input v-model="formData.upd_time" disabled></el-input></el-form-item></el-col>
            </el-row>
            <el-form-item :label="$t('select_func')">
                <el-tree class="tree-edit" ref="tree" :data="funcs" :default-checked-keys="select_funcs" node-key="func_id"
                         show-checkbox default-expand-all></el-tree>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <div class="flex-box bg-f8">
                <div class="flex-box-bd"></div>
                <el-button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</el-button>
                <el-button type="primary" @click="submit">{{$t('save')}}</el-button>
            </div>
        </div>
    </mySubPage>
</template>

<script>
    export default {
        data:function(){
            return{
                relist:false,
                op: this.$base.getRequest().op,
                formData: {
                    mod_id:'',
                    mod_cname: '',
                    funcs :[],
                    add_user:'',
                    add_time:'',
                    upd_user:'',
                    upd_time:'',
                },
                funcs: [],
                select_funcs: [],
                fee_cat:[],
                rule: {
                    mod_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}]
                }
            }
        },
        computed:{
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.formData = this.$base.leftJson(this.formData,JSON.parse(this.$base.getRequest().item));
            this.getInfo();
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getInfo: function(){
                var id = this.formData.mod_id;
                if(!id){return;}
                var data = {
                    mod_id: id
                };
                this.$base.showLoading();
                this.$request.sendPost("mod/before-upd",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.funcs = data.funcs;
                        this.select_funcs = data.select_funcs;
                        this.fee_cat = data.fee_cat;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                this.formData.funcs = [];
                var check_data = this.$refs["tree"].getCheckedNodes();
                check_data.map(item => {
                    if(item.func_type && item.func_type == 'P'){
                        this.formData.funcs.push(item.func_id)
                    }
                });

                var fee_cat = this.fee_cat.filter(item => item.fee_amt == '');
                if(fee_cat.length > 0){
                    this.$base.msgErr(this.$t('no_fee_amt'));
                    return;
                }
                this.formData.fee_cat = this.fee_cat;

                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        this.$base.showLoading();
                        this.$request.sendPost("mod/upd",this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.msgSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/system/mod_save.vue